import appModules from "./appModules";

angular
  .module("ebmeds_app", [
    "AppRoutes",
    "AppDependencies",

    ...appModules,
  ]);
